module.exports = __webpack_public_path__ + "static/tr-pikap-b0e4fc35ea0900bfe49a8ac7aeb7f130.png";